"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineOauthClientRegister = exports.OauthClientRegister = void 0;
const apis_1 = require("./apis");
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/complex-inputs/lib-es2015");
const oauth_context_form_1 = require("./oauth-context-form");
const lib_es2015_3 = require("@hodol/dom-helper/lib-es2015");
const apis_2 = require("../tenant/apis");
const Constants = require("./constants");
const entity_1 = require("../tenant/entity");
class OauthClientRegister extends HTMLElement {
    constructor() {
        super();
        this.apis = new apis_1.default();
        this.router = (0, lib_es2015_1.useRouter)();
        this.tenantApis = new apis_2.default();
        this.oauthContextForms = {};
        this.style.setProperty('display', 'block');
    }
    connectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            this.innerHTML = `
    <div class="register-form">
      <div class="register-form-field-name">Tenant Id</div>
      <div><search-selector class="tenant-pk"></search-selector></div>
      
      <div class="register-form-field-name">Oauth Client Id</div>
      <div><input class="id" /></div>
      
      <div class="register-form-field-name">Password</div>
      <div><input type="password" class="password" /></div>
      
      <div class="register-form-field-name">Confirm Password</div>
      <div><input type="password" class="password-confirm" /></div>
      
      <div class="register-form-field-name">Member Extra Keys</div>
      <div><input-list class="member-extra-key"></input-list></div>
    </div>
    
    <div class="oauth-context-form-container"></div>
    <div class="oauth-context-btn-container"><button class="append-oauth-context-btn">Append Oauth Resource Server</button></div>
    
    <div class="register-form-footer"><button class="submit-btn">Submit</button></div>`;
            this.tenantPKSelector = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'search-selector.tenant-pk');
            this.tenantPKSelector.init({ value: '', displayText: '', description: '' }, this.tenantApis.listForSearchSelector);
            this.oauthClientIdInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.id');
            this.passwordInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.password');
            this.memberExtraKeyInputList = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input-list.member-extra-key');
            const oauthContextFormContainer = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'div.oauth-context-form-container');
            (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'button.append-oauth-context-btn').addEventListener('click', () => {
                const resourceServer = prompt('Put oauth resource server name, e.g. google, facebook, kakao, naver and etc...');
                if (resourceServer === null || resourceServer === '') {
                    return;
                }
                const oauthCtxForm = this.oauthContextForms[resourceServer];
                if (oauthCtxForm !== undefined && oauthCtxForm !== null) {
                    alert(`The resource server of name ${resourceServer} already exists`);
                    return;
                }
                const form = new oauth_context_form_1.OauthContextForm();
                this.oauthContextForms[resourceServer] = form;
                form.setAttribute('resource-server', resourceServer);
                form.addEventListener('on-delete-btn-click', () => {
                    (0, lib_es2015_3.getParentElementOrThrowError)(form).removeChild(form);
                    delete this.oauthContextForms[resourceServer];
                });
                form.value = {
                    pk: 0,
                    oauth_client_pk: 0,
                    resource_server: resourceServer,
                    client_id: '',
                    client_secret: '',
                    auth_style: 1,
                    token_url: '',
                    auth_url: '',
                    redirect_url: '',
                    scopes: [],
                };
                oauthContextFormContainer.appendChild(form);
            });
            const passwordConfirmInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.password-confirm');
            (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'button.submit-btn').addEventListener('click', () => {
                if (this.passwordInput.value === '') {
                    alert(`put ${Constants.subjectName} password`);
                    return;
                }
                if (this.passwordInput.value !== passwordConfirmInput.value) {
                    alert(`${Constants.subjectName} passwords are different`);
                    return;
                }
                if (this.oauthClientIdInput.value === '') {
                    alert(`put ${Constants.subjectName} id`);
                    return;
                }
                if (this.tenantPKSelector.value === '') {
                    alert(`put ${Constants.subjectName}'s Tenant PK.`);
                    return;
                }
                void (() => __awaiter(this, void 0, void 0, function* () {
                    const insertedPKOrNull = yield this.apis.insert({
                        pk: 0,
                        tenant_pk: Number(this.tenantPKSelector.value),
                        id: this.oauthClientIdInput.value,
                        password: this.passwordInput.value,
                        member_extra_keys: this.memberExtraKeyInputList.value.map(v => v.value),
                        oauth_contexts: Object.fromEntries(Object.entries(this.oauthContextForms).map(([resourceServer, form]) => [resourceServer, form.value])),
                        tenant: (0, entity_1.newEntity)(),
                    });
                    if (insertedPKOrNull === null) {
                        return;
                    }
                    alert('Create Oauth Client Successfully!');
                    this.router.push(`/web/${Constants.routerPathGroup}/list?page_no=1&page_size=10&query=&tenant_pk=`);
                }))();
            });
        });
    }
}
exports.OauthClientRegister = OauthClientRegister;
const defineOauthClientRegister = (name) => {
    (0, lib_es2015_2.defineSearchSelector)('search-selector');
    (0, oauth_context_form_1.defineOauthContextForm)('oauth-context-form');
    (0, lib_es2015_1.defineIfUndefined)(name, OauthClientRegister);
};
exports.defineOauthClientRegister = defineOauthClientRegister;
